import React, { useState } from 'react';

const LenderSupport = ({ onNext, answers, stepKey }) => {
  const [selectedAnswer, setSelectedAnswer] = useState(answers && answers[stepKey] ? answers[stepKey] : null);

  const handleClick = (value) => {
    setSelectedAnswer(value);
    onNext(value);
  };

  return (
    <>
      <div className="qs-card__head">
        <h2 className="qs-card__title">
          Support from lender offered?
        </h2>
      </div>
      <div className="qs-card__body">
        <p className="qs-card__sub">
          Did the lender offer support or alternatives when you showed signs of financial difficulty?
        </p>
        <div className="qs-actions">
          <button 
            type="button" 
            className={`qs-btn qs-btn--yes ${selectedAnswer == 489 ? 'btn-active' : ''}`}
            onClick={() => handleClick(489)}>
            Yes
          </button>
          <button 
            type="button" 
            className={`qs-btn qs-btn--no ${selectedAnswer == 490 ? 'btn-active' : ''}`}
            onClick={() => handleClick(490)}>
            No
          </button>
        </div>
      </div>
    </>
  );
};

export default LenderSupport;
